import React from 'react';

export default class HelpLinks {

  constructor(custId) {
    this.url = 'https://blog.folksy.com/2018/10/16/how-to-use-variations-on-folksy';
    this.custId = custId;
  }

  linkFor(inputId) {
    const url = `${this.url }#${this.custId}-${inputId}`;
    return (
      <a href={url} target="_blank">More info &#8599;</a>
    );
  }

}



// WEBPACK FOOTER //
// ./src/app/item-customisations/help-links.js